module.exports = __webpack_public_path__ + "Frame400-5f79ae5a.webp";